var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFullscreenexit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #d1d5db;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M6,22.0066v-4.0066H1.9959v-2h6.0041v6.0066h-2ZM16,22.0066v-6.0066h6.0071v2h-4.0071v4.0066h-2ZM1.9959,8v-2h4.0041v-3.9798h2v5.9798H1.9959ZM16,8V2.0202h2v3.9798h4.0071v2h-6.0071Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullscreenexit);
export default __webpack_public_path__ + "static/media/fullscreenexit.b6b8b7f2ecc8a3617bf63af072a072b7.svg";
export { ForwardRef as ReactComponent };